export default __webpack_public_path__ + "static/media/Kriti.79f124e2.jpeg";